

import * as actionTypes from '../actions';
import store from 'store';
import { architeckCall } from 'database';
import { setAppProjects } from './projects'

export const updateCompanies = (objects) => {

    let objectToUpdate = objects

    // //if no array is sent create an array out of single _id sent
    if(!(objects instanceof Array)) {
        objectToUpdate = [objects]
    }

    let newStateToSet = [...store.getState().companies.app_companies]

    objectToUpdate.forEach(u => {

        newStateToSet[newStateToSet.findIndex(el => el._id === u._id)] = u;

    })

    dispatchActions(newStateToSet)

    //we need to update projects here as well
    setAppProjects()
}

export const removeCompanies = (_ids) => {

    let objectToRemove = _ids

    //if no array is sent create an array out of single _id sent
    if(!(_ids instanceof Array)) {
        objectToRemove = [_ids]
    }

    let newStateToSet = [...store.getState().companies.app_companies]

    newStateToSet = newStateToSet.filter(u => {
        return objectToRemove.includes(u._id) ? false: true
    })
   
    dispatchActions(newStateToSet)

    //we need to update projects here as well
    setAppProjects()
}

export const addCompanies = (objects) => {

    let objectToAdd = objects

    // //if no array is sent create an array out of single _id sent
    if(!(objects instanceof Array)) {
        objectToAdd = [objects]
    }

    let newStateToSet = [...store.getState().companies.app_companies]

    objectToAdd.forEach(u => {

        newStateToSet.unshift(u);

    })

    dispatchActions(newStateToSet)
    
    //we need to update projects here as well
    setAppProjects()
}

export const setAppCompanies = async() => {
    return new Promise( async (resolve, reject) => {

        const users = await architeckCall({
            method: 'get',
            url: '/api/v1/crud/companies/list?loop=true&limit=500&order=created_at__desc'
        })

        if(users.success) {

            dispatchActions(users.data)

            resolve({success: true});
            return;

        } else {

            //error reporting here
            resolve({success: false, message: 'Failed to load app Companies. '});
            return;

        }

    })

}

const dispatchActions = (data) => {

    store.dispatch({
        type: actionTypes.SET_APP_COMPANIES,
        payload: {
            objects: data
        }
    });

    return true;
}